export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13591.f0c361fb.jpg";